export default __webpack_public_path__ + "static/media/warning.a71aafe5.svg";